<section class="footer mt-5 pt-5 pb-5 white-bg">
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <div class="mb-4"><a href="layout-one"><img src="assets/images/logo-mini.png" class="public-main-logo-img"></a>
          <p class="text-muted mt-4 mb-2 pl-5 pr-5"><a href="mailto:information@tableegh.ae">information@tableegh.ae</a>
          </p>
          <h6 class="text-muted font-weight-normal text-dir-ltr  pl-5 pr-5"><a href="tel:0097143949444"
              class="text-dir-ltr">+971 4 3949444</a></h6>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-md-4 col-sm-4 mb-4">
            <h2 class="footer-list-title text-dark mb-3">{{'services' | translate}}</h2>
            <ul class="list-unstyled company-sub-menu">
              <li><a class="footer-link font-size-21" routerLink="/customer/requestService/1">{{'legalNotification' |
                  translate}}</a>
              </li>
              <li><a class="footer-link font-size-21" routerLink="/customer/requestService/2">{{'publishing' |
                  translate}}</a></li>
            </ul>
          </div>
          <div class="col-md-4 col-sm-4 mb-4">
            <h2 class="footer-list-title text-dark mb-3">{{'navigations' | translate}}</h2>
            <ul class="list-unstyled company-sub-menu">
              <li><a class="footer-link font-size-21" (click)="goToDiv('our-services-section')"
                  href="javascript:void(0)">{{'ourServices' | translate}}</a>
              </li>
              <li><a class="footer-link font-size-21" routerLink="/customer/request">{{'orderNow' | translate}}</a></li>
              <li><a class="footer-link font-size-21" (click)="goToDiv('contact-us-section')"
                  href="javascript:void(0)">{{'contactUs'
                  | translate}}</a></li>
              <li><a class="footer-link font-size-21" (click)="goToDiv('about-us-section')"
                  href="javascript:void(0)">{{'aboutUs' |
                  translate}}</a>
              </li>
              <li><a class="footer-link font-size-21" routerLink="/account/terms-conditions">{{'termsAndConditions' |
                  translate}}</a>
              </li>
              <li><a class="footer-link font-size-21" routerLink="/account/privacy-policy">{{'privacyPolicy' |
                  translate}}</a></li>
            </ul>
          </div>
          <div class="col-md-4 col-sm-4">
            <h2 class="footer-list-title text-dark mb-3">{{'ourAddress' | translate}}</h2>
            <p class="text-muted f-14">
              {{'mainOfficeAddressPart1' | translate}}<br>
              {{'mainOfficeAddressPart2' | translate}}<br>
              {{'mainOfficeAddressPart3' | translate}}</p>
            <h6 class="text-muted pb-2">{{'email' | translate}}: <a
                href="mailto:information@tableegh.ae">information@tableegh.ae</a></h6>
            <ul class="list-unstyled footer-social-list mt-4">
              <li class="list-inline-item"><a href="https://twitter.com" target="_blank"><i
                    class="fab fa-twitter fz-35 main-color"></i></a></li>
              <li class="list-inline-item"><a href="https://facebook.com" target="_blank"><i
                    class="fab fa-facebook-square fz-35 main-color"></i></a></li>
              <li class="list-inline-item"><a
                  href="https://www.linkedin.com/company/%D8%AA%D8%A8%D9%84%D9%8A%D8%BA-%D9%84%D8%AE%D8%AF%D9%85%D8%A7%D8%AA-%D8%A7%D9%84%D8%AA%D8%A8%D9%84%D9%8A%D8%BA%D8%A7%D8%AA-%D8%A7%D9%84%D9%82%D8%A7%D9%86%D9%88%D9%86%D9%8A%D8%A9/"
                  target="_blank"><i class="fab fa-linkedin fz-35 main-color"></i></a></li>
              <li class="list-inline-item"><a href="https://www.instagram.com/tableeghlegalnotifications"
                  target="_blank"><i class="fab fa-instagram fz-35 main-color"></i></a></li>
            </ul>
            <!-- <img src="assets/images/cardTypes.png" style="width: 150px;"> -->

          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="text-center mb-2">
          <div>
            <img class="ml-2 mr-2" src="assets/images/payment-method-1.png">
            <img class="ml-2 mr-2" src="assets/images/payment-method-2.png">
            <img class="ml-2 mr-2" src="assets/images/payment-method-3.png">
            <img class="ml-2 mr-2" src="assets/images/payment-method-4.png">
          </div>
        </div>
        <div class="text-center text-muted">
          <p class="mb-0 f-15"> {{'copyrights' | translate}} © {{currentYear}} {{'tableegh' | translate}}.
            {{'allRightsReserved' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</section>